import styled from 'styled-components'

const Input = styled.input`
  flex: 1;
  min-width: 1rem;  // to allow flex to size
  margin: 0.3rem;
`

export default function TextInput({ value, placeholder, onChange, ...props }) {
  const keyPressHandler = () => {}

  return (
    <Input
      type="text"
      value={value}
      onKeyPress={keyPressHandler}
      onChange={onChange}
      autoFocus={true}
      placeholder={placeholder}
      {...props}
     />
  );
}
